export default __webpack_public_path__ + "static/media/6.a14b7eaf.jpg";